import clsx from 'clsx';
import { MouseEventHandler, ReactNode } from 'react';
import { useContent } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './IconButton.css';

export const IconButton = ({
  icon,
  titleContentId,
  onClick,
  disabled,
  disableCursor,
  style,
  className,
}: {
  icon: ReactNode;
  titleContentId?: ContentId | string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  disableCursor?: boolean;
  style?: React.CSSProperties;
  className?: string;
}) => {
  const title = useContent(titleContentId || ContentId.EmptyContent);

  return (
    <div
      title={title}
      onClick={disabled ? undefined : onClick}
      style={style}
      className={clsx(
        styles.iconButtonContainer,
        disabled
          ? disableCursor
            ? styles.iconButtonContainerVariants.disabledWithCursor
            : styles.iconButtonContainerVariants.disabled
          : styles.iconButtonContainerVariants.enabled,
        className
      )}
    >
      {icon}
    </div>
  );
};
